import { List,Record } from "immutable";

import { ITEM_CARD_SEQUENCE_LIST_VIEW, TIMELINE_VIEW } from "../../../../constants/identifiers";
import createFromJS from "../../../createFromJS";

export const MobileViewRecord = Record({
  portraitViewType: ITEM_CARD_SEQUENCE_LIST_VIEW,
  landscapeViewType: TIMELINE_VIEW,
  sequenceExpandedItems: List(),
  narrativeExpandedItems: List()
});

const data = {
  objects: {
    sequenceExpandedItems: "List",
    narrativeExpandedItems: "List"
  }
};
createFromJS.registerCallback("MobileViewRecord", createFromJS.createNestedCallback(MobileViewRecord, data));
